const formatPhone = (phone: string) => {
  if (!phone) {
    return "";
  }

  // Se já está no formato E.164 (+55XXXXXXXXXXX)
  if (phone.startsWith("+55")) {
    const phoneDigits = phone.slice(3); // Remove '+55'

    // Se tem 11 dígitos (celular)
    if (phoneDigits.length === 11) {
      return `(${phoneDigits.slice(0, 2)}) ${phoneDigits.slice(2, 7)}-${phoneDigits.slice(7)}`;
    }

    // Se tem 10 dígitos (telefone fixo)
    if (phoneDigits.length === 10) {
      return `(${phoneDigits.slice(0, 2)}) ${phoneDigits.slice(2, 6)}-${phoneDigits.slice(6)}`;
    }
  }

  // Remove todos os caracteres não numéricos
  const phoneDigits = phone.replace(/\D/g, "");

  // Se tem 11 dígitos (celular)
  if (phoneDigits.length === 11) {
    return `(${phoneDigits.slice(0, 2)}) ${phoneDigits.slice(2, 7)}-${phoneDigits.slice(7)}`;
  }

  // Se tem 10 dígitos (telefone fixo)
  if (phoneDigits.length === 10) {
    return `(${phoneDigits.slice(0, 2)}) ${phoneDigits.slice(2, 6)}-${phoneDigits.slice(6)}`;
  }

  return phone;
};

export default formatPhone;
